module.exports = __webpack_public_path__ + "static/img/86061A_1_C_20220712_LC.a7ee627.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/86061A_1_C_20220712_LC.png
// module id = 440H
// module chunks = 0